import { useState } from "react";
import TextField from "@material-ui/core/TextField";
import { Tooltip, Grid, InputAdornment } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import EditIcon from "@material-ui/icons/Edit";
import { ToastMessage } from "../../../global/ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { actulizaExtraAction, actulizaExtraPrecioAction } from "../../../ducks/extrasDuck";
import BackDrop from "../../../global/BackDrop";
import { FPaquetesStyle } from "./styles";
import { useFormik } from "formik";
import * as yup from "yup";
import ControlledEditor from "../../../global/ControlledEditor"
import { obtenerExtrasPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck";
import HeaderModal from "../../../global/headerModal";

const validationSchema = yup.object({
    nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
    suplemento: yup
        .number("Ingresa un precio neto")
        .required("Precio neto es requerido"),
})

const InitalValues = {
    nombre: "",
    suplemento: 0,
}

const ActualizaExtra = (props) => {
    const { Nombre = "", idExtra = 0, Precio = 0, Descripcion = "" } = props
    const { paqueteSelect } = useSelector(store => store.proveedorTerrestre)

    const classes = FPaquetesStyle()
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const [isLoad, setIsload] = useState(false)
    const [planDescripcion, setPlanDescripcion] = useState("")
    const [descripcion, setDescripcion] = useState('<p><strong>Escribe aqui tu texto</strong></p>')
    const handleClickOpen = () => {
        setOpen(true)
        LimpiarForm()
        formik.setFieldValue("nombre", Nombre)
        formik.setFieldValue("suplemento", Precio)
        setDescripcion(Descripcion)
    }
    const handleClose = () => {
        setOpen(false)
        LimpiarForm()
    }
    const formik = useFormik({
        initialValues: InitalValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setIsload(true);
            dispatch(actulizaExtraAction({ IdExtra: idExtra, Descripcion: descripcion, Nombre: values.nombre })).then((Response) => {
                setIsload(false);
                if (Response?.status === 500) {
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ha habido un problema de conexión con el servidor",
                    });
                    return null
                }
                if (Response?.status === 400) {
                    ToastMessage.fire({
                        icon: "warning",
                        text: Response?.Message,
                    });
                    return null
                }
                dispatch(actulizaExtraPrecioAction({ 
                    IdExtra: idExtra, 
                    IdPaquete: paqueteSelect?.IdPaqueteProveedorTerrestre, 
                    Precio: values.suplemento, 
                    Descripcion: planDescripcion  
                })).then((respueta) => {
                    if (respueta?.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null
                    }
                    if (respueta?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            text: respueta?.Message,
                        });
                        return null
                    }
                    setOpen(false);
                    dispatch(obtenerExtrasPaqueteTerrestre({idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre}));
                    ToastMessage.fire({
                        icon: "success",
                        title: "Exito en la operacion",
                    });
                    LimpiarForm();
                })
            })
        },
    })
    const LimpiarForm = () => {
        formik.resetForm(InitalValues);
        setDescripcion('<p><strong>Escribe aqui tu texto</strong></p>');
    };
    const onDescripcionValue = value => {
        setDescripcion(value)
    }
    const onDescripcionPlanValue = value => {
        setPlanDescripcion(value)
    }
    return (
        <div>
            <Tooltip title="Actualizar extra">
                <span>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleClickOpen}
                    >
                        <EditIcon />
                    </Button>
                </span>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth='md'
            >
                <form onSubmit={formik.handleSubmit}>
                <HeaderModal
                    titulo="Actualizar Extra"
                    handleClose={handleClose}
                />
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="input-Nombre"
                                    label="Nombre"
                                    type="text"
                                    variant="outlined"
                                    name="nombre"
                                    value={formik.values.nombre}
                                    onChange={formik.handleChange}
                                    error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                                    helperText={formik.touched.nombre && formik.errors.nombre}
                                    className={classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="input-Suplemento"
                                    label="Suplemento"
                                    type="text"
                                    variant="outlined"
                                    name="suplemento"
                                    value={formik.values.suplemento}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.suplemento &&
                                        Boolean(formik.errors.suplemento)
                                    }
                                    helperText={
                                        formik.touched.suplemento && formik.errors.suplemento
                                    }
                                    className={classes.textField}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">{paqueteSelect?.Moneda?.Clave}</InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ControlledEditor 
                                    height="100px" 
                                    onValue={onDescripcionValue} 
                                    onValuePlan={onDescripcionPlanValue} 
                                    content={descripcion} 
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{padding: "1rem", paddingRight: "1.5rem"}}>
                        <Button onClick={handleClose} color="secondary" variant="contained">
                            Cancelar
                        </Button>
                        <Button type="submit" color="primary" variant="contained">
                            Agregar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <BackDrop open={isLoad} />
        </div>
    );
};
export default ActualizaExtra;
